export default "__VITE_ASSET__D5vhVVho__"